import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const NotFound = () => {
  <Helmet>
    <title>
      Not Found | EduZ Tuition - Education made eZ
    </title>
  </Helmet>

  return (
    <div className="main-page-wrapper p0">
      <div className="error-page d-lg-flex align-items-center">
        <div className="img-holder order-lg-last">
          <img
            src="/images/media/404.svg"
            alt="media"
            className="w-100 illustration"
          />
          <img
            src="/images/media/404-q.svg"
            alt="media"
            className="shapes qus"
          />
        </div>
        <div className="text-wrapper order-lg-first">
          <div className="logo">
            <Link to="/">
              <img src="/images/logo/eduztuition-logo-small.webp" alt="logo" />
            </Link>
          </div>
          <h1 className="font-slab">
            Opps, <br />
            Looks like we <br />
            sent you the <br />
            wrong way.
          </h1>
          <p className="font-rubik">
            Let us guide you back!
          </p>

          <Link
            to="/"
            className="back-home font-rubik d-flex align-items-center justify-content-center"
          >
            <span>Back to Home</span>
            <img src="/images/icon/53.svg" alt="icon" />
          </Link>
        </div>
        {/* /.text-wrapper */}
      </div>
      {/* /.error-page */}
    </div>
  );
};

export default NotFound;
